import React, { useState } from "react"
import { Spinner } from "react-bootstrap"
import FsLightbox from "fslightbox-react"
import Settings from "../../common/Settings"
import { useTranslation } from "react-i18next"
import "./modernImage.css"

/**
 * ModernImageViewer - Enhanced image component with lightbox functionality
 * Features:
 * - Lightbox integration
 * - Loading states
 * - Error handling
 * - Better image optimization
 * - Hover effects
 */
const ModernImageViewer = ({
  imagePath,
  alt = "",
  maxHeight = "250px",
  className = "",
  showLightbox = true,
  aspectRatio = null,
}) => {
  const { t } = useTranslation("global")
  const [loading, setLoading] = useState(true)
  const [error, setError] = useState(false)
  const [lightboxToggler, setLightboxToggler] = useState(false)
  console.log(imagePath)
  const fullImageUrl = `${Settings.BasePath}files/${imagePath}`
  const thumbnailUrl = `${Settings.BasePath}files/thumb/${imagePath}`

  const handleImageLoad = () => {
    setLoading(false)
    setError(false)
  }

  const handleImageError = () => {
    setLoading(false)
    setError(true)
  }

  const openLightbox = () => {
    if (showLightbox && !error) {
      setLightboxToggler(!lightboxToggler)
    }
  }

  const containerStyle = {
    maxHeight,
    ...(aspectRatio && { aspectRatio }),
  }

  if (!imagePath) {
    return (
      <div className="modern-image-placeholder" style={containerStyle}>
        <div className="modern-image-placeholder-content">
          <i className="fa fa-image text-muted"></i>
          <p className="text-muted mb-0">{t("No image available")}</p>
        </div>
      </div>
    )
  }

  return (
    <>
      <div
        className={`modern-image-container ${className} ${
          showLightbox ? "clickable" : ""
        }`}
        style={containerStyle}
        onClick={openLightbox}
      >
        {loading && (
          <div className="modern-image-loading">
            <Spinner animation="border" size="sm" />
          </div>
        )}

        {error ? (
          <div className="modern-image-error">
            <i className="fa fa-exclamation-triangle text-warning"></i>
            <p className="text-muted mb-0 mt-2">{t("Failed to load image")}</p>
          </div>
        ) : (
          <img
            src={thumbnailUrl}
            alt={alt}
            className="modern-image"
            onLoad={handleImageLoad}
            onError={handleImageError}
            loading="lazy"
            style={{ display: loading ? "none" : "block" }}
          />
        )}

        {showLightbox && !error && !loading && (
          <div className="modern-image-overlay">
            <div className="modern-image-overlay-content">
              <i className="fa fa-expand"></i>
              <span className="ms-2">{t("View full size")}</span>
            </div>
          </div>
        )}
      </div>

      {/* Lightbox */}
      {showLightbox && (
        <FsLightbox
          toggler={lightboxToggler}
          sources={[fullImageUrl]}
          type="image"
        />
      )}
    </>
  )
}

export default ModernImageViewer
